<template>
  <el-dialog
      title="获取退货地址时机"
      :visible.sync="visible"
      center
      width="400px"
			:loading="loading"
      @close="handlerCancel"
  >

    <el-form ref="form" :model="form" label-width="100px"	v-loading="loading">
		 <el-form-item label="获取时间">
		   <el-radio-group v-model="form.sync_return_address_type">
				 <el-radio :label="10" size="large">发货后24小时</el-radio>
				 <el-radio :label="20" size="large">签收后</el-radio>
			 </el-radio-group>
		 </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handlerCancel">取 消</el-button>
      <el-button type="primary" @click="handlerConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import Vue from 'vue';
import { mapActions,mapState,mapMutations } from "vuex";
export default {
  data() {
    return {
      visible: false,
      form:{
      	sync_return_address_type: 10,
      },
			loading: false
    }
  },
  mounted() {

  },
  methods: {
		...mapActions({
			opBusinessSetSyncReturnAddressType:"ucenter/opBusinessSetSyncReturnAddressType",
			getUserinfoData:"ucenter/getUserinfoData"
		}),
    open(){
			this.loading = true;
      this.getUserinfoData({
        data:{},
        success:(res)=>{
					console.log(res)
					this.form.sync_return_address_type = res.data.sync_return_address_type;
					this.loading = false;
        },
      })
      this.visible = true;
    },
    handlerConfirm(){
      this.opBusinessSetSyncReturnAddressType({
        data:this.form,
        success:(res)=>{
					this.$message.success(res.msg);
					this.visible = false;
        },
      })
    },
    handlerCancel(){
      this.visible = false;
    },
  }
}
</script>

<style scoped>
.el-form{
	display: flex;
	gap: 10px;
	align-items: center;
	justify-content: center;
}
.el-input-group--append .el-input__inner{
	text-align: center;
}
</style>